import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../components/AuthContext";

/**
 * Użycie:
 * <RedirectIfAuth to="/konto"><LoginPage/></RedirectIfAuth>
 */
export default function RedirectIfAuth({ children, to = "/" }) {
  const { user, isAuthReady } = useContext(AuthContext);

  if (!isAuthReady) return null;
  if (user) {
    const inviteCode = window.localStorage.getItem("fifa_pending_invite");
    return (
      <Navigate
        to={inviteCode ? `/fifa-zaproszenie/${encodeURIComponent(inviteCode)}` : to}
        replace
      />
    );
  }
  return children;
}
